// Captación de la landing pública: origen de la visita (UTM / fbclid), consentimiento y Meta Pixel.
//
// El origen se guarda en el PRIMER contacto de la sesión y viaja con el lead: un lead guardado sin
// su campaña no se puede reconstruir después, y es el dato que dirá qué anuncio paga.
//
// El Pixel NO se carga sin dos cosas: `REACT_APP_META_PIXEL_ID` definido (apagado hasta tener la
// cuenta de anuncios) y consentimiento explícito del visitante. Sin consentimiento, `track` es un
// no-op: no se encola nada para "mandar después".

const CLAVE_ORIGEN = "sebbia_origen_visita";
const CLAVE_CONSENTIMIENTO = "sebbia_consentimiento_medicion";
const PARAMS_ORIGEN = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "fbclid", "gclid"];

export const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

// Eventos estándar de Meta que usa la landing. `Schedule` queda definido para el agendamiento.
export const EVENTOS = {
  vistaContenido: "ViewContent",
  lead: "Lead",
  contacto: "Contact",
  agenda: "Schedule",
};

export function capturarOrigen() {
  try {
    const guardado = sessionStorage.getItem(CLAVE_ORIGEN);
    if (guardado) return JSON.parse(guardado);
  } catch {
    /* almacenamiento bloqueado: se calcula igual, sólo que no persiste */
  }
  const params = new URLSearchParams(window.location.search);
  const origen = {};
  PARAMS_ORIGEN.forEach((k) => {
    const v = params.get(k);
    if (v) origen[k] = v.slice(0, 200);
  });
  if (document.referrer) origen.referrer = document.referrer.slice(0, 300);
  origen.landing_path = window.location.pathname + window.location.search;
  try {
    sessionStorage.setItem(CLAVE_ORIGEN, JSON.stringify(origen));
  } catch {
    /* ídem */
  }
  return origen;
}

/** `"aceptado"`, `"rechazado"` o `null` si todavía no contesta. */
export function leerConsentimiento() {
  try {
    return localStorage.getItem(CLAVE_CONSENTIMIENTO);
  } catch {
    return null;
  }
}

export function guardarConsentimiento(valor) {
  try {
    localStorage.setItem(CLAVE_CONSENTIMIENTO, valor);
  } catch {
    /* sin almacenamiento el banner vuelve a aparecer en la próxima visita: aceptable */
  }
  if (valor === "aceptado") cargarPixel();
}

let pixelCargado = false;

export function cargarPixel() {
  if (!PIXEL_ID || pixelCargado || typeof window === "undefined") return;
  if (leerConsentimiento() !== "aceptado") return;
  pixelCargado = true;
  /* eslint-disable */
  // Snippet oficial de Meta (fbevents.js), sin el <noscript>: sin JS tampoco hay consentimiento.
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

export function track(evento, datos) {
  if (!pixelCargado || typeof window.fbq !== "function") return;
  window.fbq("track", evento, datos);
}
